<template>
  <div class="test-content">
    <ul>
        <ToDoLi v-for = "(pep,index) in arr" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></ToDoLi>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ToDoLi from '../components/ToDoLi';
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'LiveValue',
  components:{
    'ToDoLi':ToDoLi
  },
  data () {
    return {
        arr:[
            {'num':1,'order':'1/40','title':'我认为创造出属于自己独一无二的作品是证明个人价值最好的方式。','A':'是','B':'否','show':false},
            {'num':2,'order':'2/40','title':'我很容易对一件事物感到厌倦，然后重新寻找让自己更感兴趣的东西。','A':'是','B':'否','show':false},
            {'num':3,'order':'3/40','title':'我喜欢参加有自己执行发挥空间的活动，不喜欢完全按照固有流程开展的活动。','A':'是','B':'否','show':false},
            {'num':4,'order':'4/40','title':'在学生会/社团中，我非常希望自己的提议得到大家的认可和关注。','A':'是','B':'否','show':false},
            {'num':5,'order':'5/40','title':'我一直关注学校的创业活动，并寻找可以让我创立自己事业（公司）的创意（点子）。','A':'是','B':'否','show':false},
            {'num':6,'order':'6/40','title':'我很乐于参加学校组织的志愿者活动，可以帮助别人我感到很开心。','A':'是','B':'否','show':false},
            {'num':7,'order':'7/40','title':'在志愿者活动中体现自己的价值使我特别高兴。','A':'是','B':'否','show':false},
            {'num':8,'order':'8/40','title':'如果我的行为可以为他人带来便利或者帮助，我会毫不犹豫的行动。','A':'是','B':'否','show':false},
            {'num':9,'order':'9/40','title':'只要能对活动有益，我不会太在乎自己在活动中承担哪方面的职责。','A':'是','B':'否','show':false},
            {'num':10,'order':'10/40','title':'我以后从事的工作是否对社会有所贡献对我来说很重要。','A':'是','B':'否','show':false},
            {'num':11,'order':'11/40','title':'我认为成功就是克服不可能的障碍，解决不可能的难题，战胜强硬的对手。','A':'是','B':'否','show':false},
            {'num':12,'order':'12/40','title':'我乐于接受比较困难的任务，督促自己不断进步。','A':'是','B':'否','show':false},
            {'num':13,'order':'13/40','title':'参加一个不是自己本专业的挑战并取得不错的成绩，我觉得很有成就感。','A':'是','B':'否','show':false},
            {'num':14,'order':'14/40','title':'我希望将来从事的工作具有很强的挑战性。','A':'是','B':'否','show':false},
            {'num':15,'order':'15/40','title':'我愿意在寻找兼职时，挑战自己不熟悉的工作。','A':'是','B':'否','show':false},
            {'num':16,'order':'16/40','title':'如果我参与的社团或者学生会对我有诸多的限制，会让我觉得难以接受。','A':'是','B':'否','show':false},
            {'num':17,'order':'17/40','title':'我喜欢有自己独立的时间做自己喜欢的事情，并且不喜欢被打扰。','A':'是','B':'否','show':false},
            {'num':18,'order':'18/40','title':'我在学生活动中接到一项任务，我希望能让我用自己的方式，按自己的计划去开展。','A':'是','B':'否','show':false},
            {'num':19,'order':'19/40','title':'我喜欢在课余时间旁听自己感兴趣的课程，不必受到课表和教学制度的限制。','A':'是','B':'否','show':false},
            {'num':20,'order':'20/40','title':'我认为成功的职业应该允许我有充分的自主和自由。','A':'是','B':'否','show':false},
            {'num':21,'order':'21/40','title':'老师安排小组任务时，我会主动组织小组成员讨论学习，分工合作。','A':'是','B':'否','show':false},
            {'num':22,'order':'22/40','title':'在与其他同学一起承办某个活动时，我更愿意承担沟通交流，协调资源的职责。','A':'是','B':'否','show':false},
            {'num':23,'order':'23/40','title':'我认为担任学生会或者社团的职务可以作为衡量我能力的重要指标。','A':'是','B':'否','show':false},
            {'num':24,'order':'24/40','title':'在未来的工作中，与其加薪，我更喜欢升职。','A':'是','B':'否','show':false},
            {'num':25,'order':'25/40','title':'我希望凭借自己的能力带领团队（如学生会或者社团）取得更好的发展。','A':'是','B':'否','show':false},
            {'num':26,'order':'26/40','title':'我喜欢将自己本专业所学的知识应用到实际的工作、生活当中去。','A':'是','B':'否','show':false},
            {'num':27,'order':'27/40','title':'我热爱自己的专业，并且利用课余时间不断的学习，提高专业技能。','A':'是','B':'否','show':false},
            {'num':28,'order':'28/40','title':'在择业时，我希望从事自己本专业的工作，成为一名专业型人才。','A':'是','B':'否','show':false},
            {'num':29,'order':'29/40','title':'我认为，将我的专业水平发展到一个更具有竞争力的层次是我自己职业成功的必要条件。','A':'是','B':'否','show':false},
            {'num':30,'order':'30/40','title':'与其花时间在社团内协调人员，我更喜欢在图书馆阅读专业书籍。','A':'是','B':'否','show':false},
            {'num':31,'order':'31/40','title':'我认为平衡好学习、社团活动和个人时间对自己来说非常重要。','A':'是','B':'否','show':false},
            {'num':32,'order':'32/40','title':'我认为好学生不仅仅是学业上有出色的表现，还应该参与学生活动，有几个玩的好的朋友。','A':'是','B':'否','show':false},
            {'num':33,'order':'33/40','title':'我未来择业比较倾向于找一份能最小化个人和家庭之间冲突的工作。','A':'是','B':'否','show':false},
            {'num':34,'order':'34/40','title':'我喜欢参加活动时间具有弹性的社团，以便我可以更好的协调自己的时间。','A':'是','B':'否','show':false},
            {'num':35,'order':'35/40','title':'如果社团/学生会职务会占用我过多的个人时间，以致我不能很好的平衡自己的学习生活，我选择放弃。','A':'是','B':'否','show':false},
            {'num':36,'order':'36/40','title':'我希望可以进入政府部门、事业单位工作。','A':'是','B':'否','show':false},
            {'num':37,'order':'37/40','title':'我规律的上课休息，喜欢跟班级大多数人选择一样的课程。','A':'是','B':'否','show':false},
            {'num':38,'order':'38/40','title':'对我而言，安定与稳定比自由和自主更加重要。','A':'是','B':'否','show':false},
            {'num':39,'order':'39/40','title':'我喜欢参与每段时间都有固定活动，且活动难度不大的社团。','A':'是','B':'否','show':false},
            {'num':40,'order':'40/40','title':'我自己一个人时不会参加自己完全不了解的比赛或者活动。','A':'是','B':'否','show':false},
          ],
      orderArray:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
      data:[2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2],
      submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-生涯罗盘');
    this.getNum()
  },
  methods:{
    // 获取随机显示的题
    getNum(){
      let nums = Math.floor(Math.random()*this.orderArray.length) //从orderArray里面随机一个地址并 赋给变量nums
      let nextNum = this.orderArray[nums]
      this.orderArray.splice(nums,1)
      this.arr.map((item)=>{
        if(item.show){
          item.show=false
        }
        // 修改将要显示的题的状态和序号
        if(item.num==nextNum){
          item.show=true
          item.order = (40-this.orderArray.length)+'/40'
          return true
        }
      })
    },
    showMsg(cur,res){
      this.getNum()
      this.$set(this.data,cur-1,res)
      if(this.orderArray.length==0&&this.submitNum==0){
        this.submitNum =1
        let result = ''
        this.data.map((item,index)=>{
          result+=index+1+"$"+item
          if(index<39){
            result+='}'
          }
        })
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded'},
          data:qs.stringify({
            submitdata: result,
            openId: this.shengyaUser.openid
            }),
          url:'/cob/saveCosValueAnswer.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            this.$store.commit('showMessage', {
              message: '恭喜你，第3关已解锁',
              type: 'success'
            })
            let cosAnswer = response.data
            let shengyaUser = cosAnswer.data.user
            this.$bus.$emit('play-finish', shengyaUser)
          }
        })
        .catch((error)=>{
          console.log(error);
        });
      }
    }
  }
}
</script>
<style>


</style>
